__turbopack_context__.v({
  "detailCard": "AvatarDetailCard-module__81Nlnq__detailCard",
  "header": "AvatarDetailCard-module__81Nlnq__header",
  "item": "AvatarDetailCard-module__81Nlnq__item",
  "itemLabel": "AvatarDetailCard-module__81Nlnq__itemLabel",
  "textBody": "AvatarDetailCard-module__81Nlnq__textBody",
  "title": "AvatarDetailCard-module__81Nlnq__title",
});
